/**
 * Implement Gatsby's browser APIs in this file.
 *
 * @see https://www.gatsbyjs.org/docs/browser-apis/
 */

import NProgress from 'nprogress';
import React from 'react';
import ReactModal from 'react-modal';
import storage from 'store2';

import '@skippay/core/stylesheets/index.sass';
import { init as initNamespace } from '@skippay/core/global/window';
import FirebaseProvider from '@skippay/core/providers/FirebaseProvider/FirebaseProvider';
import GrowthBookProvider from '@skippay/core/providers/GrowthBookProvider/GrowthBookProvider';

import GlobalStyles from 'components/GlobalStyles';
import apolloClient from 'global/apolloClient';
import { init as initReferralModule } from 'modules/referral';
import ProvidersBrowser from 'providers/Browser';
import ProvidersCommon from 'providers/Common';
import { ModalProvider } from 'providers/Modal/ModalContext';

import './src/styles/global.css';

export const onRouteUpdateDelayed = () => {
	NProgress.start();
};

export const onRouteUpdate = () => {
	NProgress.done();
};

export function onClientEntry() {
	NProgress.configure({ showSpinner: false });

	const appRoot = document.getElementById('___gatsby');

	if (process.env.NODE_ENV === `development` && !storage.get(`NO_MOCK`)) {
		// eslint-disable-next-line global-require
		const { worker } = require('./mockWorkerBrowser');
		worker.start({
			onUnhandledRequest: ({ method, url }) => {
				if (url.pathname.startsWith(process.env.API_BASE_URL)) {
					throw new Error(`Unhandled ${method} request to ${url}`);
				}
			},
		});
	}

	// defeats hot-module-replacement by triggering reload
	if (
		process.env.NODE_ENV === 'development' &&
		module.hot &&
		!window.localStorage.getItem('USE_HMR')
	) {
		module.hot.addStatusHandler((status) => {
			if (status === 'apply') window.location.reload();
		});
	}

	if (process.env.GATSBY_PROFILING) {
		// eslint-disable-next-line global-require
		const whyDidYouRender = require('@welldone-software/why-did-you-render');
		whyDidYouRender(React, {
			trackAllPureComponents: true,
		});
	}

	/**
	 * ReactModal needs to know appRoot element, for it hides the app for
	 * screenreaders and other assistive technologies when modal is opened.
	 * @see http://reactcommunity.org/react-modal/examples/set_app_element.html
	 */
	ReactModal.setAppElement(appRoot);

	initNamespace({
		environment: process.env.TARGET_ENV,
		name: process.env.npm_package_name,
		version: process.env.npm_package_version,
	});

	initReferralModule(apolloClient);
}

export function wrapRootElement({ element }) {
	return (
		<ProvidersCommon>
			<ProvidersBrowser>
				<FirebaseProvider>
					<GrowthBookProvider>
						<ModalProvider>
							<GlobalStyles />
							{element}
						</ModalProvider>
					</GrowthBookProvider>
				</FirebaseProvider>
			</ProvidersBrowser>
		</ProvidersCommon>
	);
}
